import { useContext, useEffect, useLayoutEffect, useState } from "react";
import Footerr from "../../components/Footerr";
import NavBar from "../../components/Navbarr";
import "./UsersScreen.scss";
import { UserContext } from "../../components/context/userContext";
import AccessDenied from "../../components/AccessDenied";
import SideBarAdmin from "../../components/SideBarAdmin";
import axios from "axios";
import { usersBypaginationService } from "../../services/get-users.by-pagination";
import { getFromLocalStorage } from "../../utils";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const UsersScreen = () => {
  const { user } = useContext(UserContext);
  const { width } = useWindowDimensions();

  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 8;
  const [loading, setLoading] = useState(false);

const fetchUsers = async (pageNumber = 1) => {
    let token = await localStorage.getItem("token");

    
  
  try {
    setLoading(true);

    const response = await usersBypaginationService(
      token,
      pageNumber,
      limit
    );

    if (!response.success) {
      console.error(response.message);
      return;
    }

    setUsers(response.content.users);
    setTotalPages(response.content.pagination.totalPages);
    setPage(pageNumber);
  } catch (error) {
    console.error("fetchUsers error", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchUsers(1);
  }, []);

  if (user?.role !== 1) {
    return (
      <>
        <NavBar />
        <div className="dashboard-container">
          <AccessDenied />
        </div>
        <Footerr />
      </>
    );
  }

  return (
    <>
      <NavBar />

      <div className="dashboard-container">
        <div className="side-bar-container">
          <SideBarAdmin widthWindow={width} screen="users" />
        </div>

        <div className="body-container">
          <div className="header-body">
            <div className="header-left">
              <h2>Users</h2>
            </div>
          </div>

          <div className="admin-table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Verified</th>
                  <th>Joined</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={5} className="admin-loading-row">
                      Loading users…
                    </td>
                  </tr>
                ) : users.length > 0 ? (
                  users.map((u, index) => (
                    <tr key={u._id}>
                      <td>{(page - 1) * limit + index + 1}</td>
                      <td>{u.name}</td>
                      <td>{u.email}</td>
                      <td>
                        <span
                          className={`admin-badge ${
                            u.verified ? "is-success" : "is-danger"
                          }`}
                        >
                          {u.verified ? "Verified" : "Pending"}
                        </span>
                      </td>
                      <td>{new Date(u.createdAt).toLocaleDateString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="admin-empty-row">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination">
            <button disabled={page === 1} onClick={() => fetchUsers(page - 1)}>
              ◀ Prev
            </button>

            <span>
              Page {page} / {totalPages}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => fetchUsers(page + 1)}
            >
              Next ▶
            </button>
          </div>
        </div>
      </div>

      <Footerr />
    </>
  );
};

export default UsersScreen;
